import i18n from "i18n";
import { AuthService } from "services/AuthService";

function isHex(h) {
  var regexp = /^[0-9a-fA-F]+$/;
  return regexp.test(h);
}

/**
 * If the number is a hex prepend 0x to the number
 * @param {*} number
 * @returns BigInt
 */
function toBigInt(number) {
  if(!Number.isInteger(number) && !isHex(number)){
    console.error('toBigInt Invalid number:', number);
    throw new Error('Invalid number');
  }

  if(isHex(number)) number = "0x" + number;
  return BigInt(number);
}

const capitalize = (data) => {
  return data.charAt(0).toUpperCase() + data.slice(1)
}

/**
 * Comprueba que un valor tenga contenido sea distinto de null, undefined o vacío
 *
 * @param {*} value
 * @returns boolean
 */
const isNotNullOrWhitespace = (value) => {
  return value && value.trim() !== "";
};

/**
 * Comprueba que un array de valores tengan contenido
 *
 * @param {*} values
 * @returns
 */
const checkMultipleIsNotNullOrWhitespace = (values) => {
  return values.every(isNotNullOrWhitespace);
};

/** traduce al idioma del usuario los estados de las órdenes */
const translateOrder = (status) => {
  switch (status) {
    case "Creation finished":
      return i18n.t("creation.finished");
    case "BAS":
        return i18n.t("orders.klasses.PRE");
    case "REQ":
        return i18n.t("orders.klasses.PRE");
    case "ADJ":
        return i18n.t("orders.klasses.ADJ");
    case "SALE":
        return i18n.t("orders.types.SALE");
    case "PUR":
        return i18n.t("orders.klasses.PUR");
    case "REF":
        return i18n.t("orders.klasses.REF");
    case "PRO":
        return i18n.t("orders.klasses.PRO");
    case "BRE":
        return i18n.t("breaked");
    case "LOSS":
        return i18n.t("unknown.lost");
    case "AUD":
      return i18n.t("orders.klasses.AUD");
    default:
      return status;
  }
};

const getPermissionById = (id) => {
  let permissions = AuthService.getPermissionsWithId();
  const exists = permissionsArray.some(p => p.id === id);
  return exists;
  
};

export { toBigInt, isNotNullOrWhitespace, checkMultipleIsNotNullOrWhitespace, capitalize, translateOrder, getPermissionById};
